import { render, staticRenderFns } from "./contentBannerMove.vue?vue&type=template&id=067f2e64&"
import script from "./contentBannerMove.vue?vue&type=script&lang=js&"
export * from "./contentBannerMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports